module.exports = __webpack_public_path__ + "14ccd366749aa86937c5c561bdec21e9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/nail-polish-s.png
// module id = 2566
// module chunks = 0